import { X } from 'lucide-react'
import { useState } from 'react'
import { useRedirect } from '@/contexts/redirect-context'

export function SaleBanner() {
  const [isVisible, setIsVisible] = useState(true)
  const { openRedirect } = useRedirect()

  if (!isVisible) return null

  const handleBannerClick = () => {
    openRedirect('/billing')
  }

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation() // Prevent navigation when clicking dismiss
    setIsVisible(false)
  }

  return (
    <div 
      onClick={handleBannerClick}
      className="relative bg-gradient-to-r from-emerald-300/10 via-green-200/15 to-emerald-300/10 border-b border-emerald-300/10 text-center py-3 px-4 text-sm cursor-pointer hover:from-emerald-300/15 hover:via-green-200/20 hover:to-emerald-300/15 transition-all"
    >
      <span className="text-emerald-200/90">
        🌿 Spring Sale: <span className="font-semibold text-emerald-100">40% off all plans</span>
        <span className="hidden sm:inline"> · Ends May 1st</span>
      </span>
      <button
        onClick={handleDismiss}
        className="absolute right-4 top-1/2 -translate-y-1/2 p-1.5 rounded-md text-emerald-200/50 hover:text-emerald-100 hover:bg-emerald-300/10 transition-all"
        aria-label="Dismiss banner"
      >
        <X className="size-4" />
      </button>
    </div>
  )
}
